var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1216 7.55835H12.8452C12.9753 7.91454 13.0464 8.29894 13.0464 8.69958V13.5235C13.0464 13.6905 13.0173 13.8508 12.9644 14H15.0745C15.8627 14 16.504 13.3587 16.504 12.5705V9.94077C16.504 8.62712 15.4353 7.55835 14.1216 7.55835Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.45763 8.69961C3.45763 8.29893 3.5287 7.91457 3.6588 7.55838H2.38245C1.06876 7.55838 0 8.62714 0 9.94083V12.5705C0 13.3587 0.64124 14 1.42947 14H3.5396C3.4867 13.8508 3.45763 13.6905 3.45763 13.5235V8.69961Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71101 6.31715H6.79309C5.47941 6.31715 4.41064 7.38591 4.41064 8.6996V13.5235C4.41064 13.7866 4.62397 14 4.88713 14H11.617C11.8801 14 12.0935 13.7866 12.0935 13.5235V8.6996C12.0935 7.38591 11.0247 6.31715 9.71101 6.31715Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25191 0C6.67203 0 5.38672 1.28532 5.38672 2.86522C5.38672 3.93685 5.97819 4.87278 6.85168 5.36416C7.26599 5.59722 7.74364 5.73041 8.25191 5.73041C8.76018 5.73041 9.23783 5.59722 9.65214 5.36416C10.5257 4.87278 11.1171 3.93682 11.1171 2.86522C11.1171 1.28535 9.83178 0 8.25191 0Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.22091 2.67058C2.03936 2.67058 1.07812 3.63181 1.07812 4.81336C1.07812 5.99491 2.03936 6.95615 3.22091 6.95615C3.52062 6.95615 3.80603 6.89406 4.06529 6.78247C4.51354 6.58948 4.88314 6.24786 5.11184 5.81995C5.27237 5.51962 5.36369 5.177 5.36369 4.81336C5.36369 3.63184 4.40246 2.67058 3.22091 2.67058Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2834 2.67058C12.1019 2.67058 11.1406 3.63181 11.1406 4.81336C11.1406 5.17703 11.2319 5.51965 11.3925 5.81995C11.6212 6.24789 11.9908 6.58951 12.439 6.78247C12.6983 6.89406 12.9837 6.95615 13.2834 6.95615C14.465 6.95615 15.4262 5.99491 15.4262 4.81336C15.4262 3.63181 14.465 2.67058 13.2834 2.67058Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMember);
export default __webpack_public_path__ + "static/media/member.83a0e588696fd89552ae1149719b0920.svg";
export { ForwardRef as ReactComponent };